import { get, post } from '@/util/auth'

import {
  API_ROUTE_SHOP_CREDIT_CHECK,
  API_ROUTE_SHOP_CREDIT_CHECK_DEMO,
  API_ROUTE_SHOP_INVENTORY,
  API_ROUTE_SHOP_ORDER,
  API_ROUTE_SHOP_ORDER_SMS,
  API_ROUTE_SHOP_ORDER_STATUS,
  API_ROUTE_SHOP_ORDERS,
  API_ROUTE_SHOP_TEMP_ORDER_CONFIRMATION,
  API_ROUTE_SHOP_TEMP_ORDERS,
  API_ROUTE_SHOP_ORDER_IMEI,
} from './apiRoutes'

export const getShopInventoryAPI = async (customerId: number) => {
  const response = await get(API_ROUTE_SHOP_INVENTORY.replace(':customer_id', String(customerId)))

  return transformProductsFromWS(response)
}

const transformProductsFromWS = (result: any) => ({
  ...result,
  inventory: result.inventory.map((product: any) => ({
    ...product,
    desc: product.desc,
    parents: product.parents.map((parentId: any) => Number(parentId)),
  })),
})

export const postTempOrder = async ({
  customerId,
  payload,
}: {
  customerId: number
  payload: any
}) => {
  const response = await post<{ temp_order_id: number }>(
    API_ROUTE_SHOP_TEMP_ORDERS.replace(':customer_id', String(customerId)),
    payload
  )
  // @ts-ignore
  return response.temp_order_id
}

export const loadTempOrders = () => get(API_ROUTE_SHOP_TEMP_ORDERS)

export const postCreditCheckAPI = (orderId: number) =>
  post(API_ROUTE_SHOP_CREDIT_CHECK.replace(':order_id', String(orderId)))

export const postCreditCheckDemoAPI = (orderId: number) =>
  post(API_ROUTE_SHOP_CREDIT_CHECK_DEMO.replace(':order_id', String(orderId)))

export const getCreditCheckAPI = (orderId: number) =>
  get(API_ROUTE_SHOP_CREDIT_CHECK.replace(':order_id', String(orderId)))

export const postOrderConfirmation = (orderId: number) =>
  post(API_ROUTE_SHOP_TEMP_ORDER_CONFIRMATION.replace(':order_id', String(orderId)))

export const getShopOrdesAPI = () => get(API_ROUTE_SHOP_ORDERS)

export const getEcomOrderAPI = (orderId: number) =>
  get(API_ROUTE_SHOP_ORDER.replace(':order_id', String(orderId)))

export const postEcomOrderAPI = ({ orderId, payload }: { orderId: number; payload: any }) =>
  post(API_ROUTE_SHOP_ORDER.replace(':order_id', String(orderId)), payload)

export const postEcomOrderStatusAPI = ({
  orderId,
  statusId,
  payload,
}: {
  orderId: number
  statusId: number
  payload: any
}) =>
  post(API_ROUTE_SHOP_ORDER_STATUS.replace(':order_id', String(orderId)), {
    statusId,
    ...payload,
  })

export const sendEcomOrderSmsAPI = ({
  orderId,
  aliasId,
  end_user_receiver,
  order_user_receiver,
  message,
}: {
  orderId: number
  aliasId: number
  end_user_receiver: number
  order_user_receiver: number
  message: string
}) =>
  post(API_ROUTE_SHOP_ORDER_SMS.replace(':order_id', String(orderId)), {
    aliasId,
    end_user_receiver,
    order_user_receiver,
    message,
  })

export const postShopOrderProductImei = ({
  imei,
  orderId,
  orderLineId,
}: {
  imei: string
  orderId: number
  orderLineId: number
}) =>
  post(
    API_ROUTE_SHOP_ORDER_IMEI.replace(':order_id', String(orderId)).replace(
      ':orderLineId',
      String(orderLineId)
    ),
    { imei }
  )
